/**
 * Created by PhpStorm
 * Author: Mikhail Zheludkov <mzheludkov@clubautomation.com>
 * Date: 11/22/2015
 * Time: 7:31 PM
 *
 * A Dialog Form widget is used for creation and validation dialog form, binding event handlers
 * This widget can be used as a parent widget for dialog form widgets
 */
(function ($) {
    $.widget('ca.caDialogForm', {
        options: {
            dialog: null,
            form: null,
            formParams: {},
            formUrl: '',
            dialogOptions: {
                caProUI: true,
                staticForm: false
            },
            cancelButtonId: '',
            submitButtonId: '',
            onDialogOpened: null,
            onDialogFailed: null,
            submitCallback: function() {},
            cancelCallback: function() {}
        },

        _create: function () {
            var self = this;
            $(document).ready(function () {
                self.element.on('click', function () {
                    self.openDialog();

                    return false;
                });
            });
        },

        openDialog: function() {
            var self = this;
            self.options.dialog = $('<div id="ca-form-wrapper"></div>').appendTo('body');
            $.caPost(
                self.options.formUrl,
                self.options.formParams,
                function (response) {
                    if (response.status) {
                        self.options.dialog.html(response.content);
                        self.options.form = self.options.dialog.find('form');
                        if (typeof self.options.onDialogOpened == 'function') {
                            self.options.onDialogOpened();
                        }

                        self.options.dialog.caDialog(self.options.dialogOptions);

                        setTimeout(function() {
                            $('.ca-form-element-autofocus').focus();
                            self._bindEvents();
                        }, 0);
                    } else {
                        if (typeof self.options.onDialogFailed == 'function') {
                            self.options.onDialogFailed();
                        }
                        $.caAlert(response.message);
                    }
                },
                'json'
            );
        },

        _bindEvents: function () {
            this._cancelEvent();

            this._submitEvent();
        },

        _cancelEvent: function () {
            var self = this;
            if (self.options.cancelButtonId) {
            self.options.dialog.find('#' + self.options.cancelButtonId).on('click', function () {
                self.options.dialog.remove();
                if (self.options.cancelCallback && $.isFunction(self.options.cancelCallback)) {
                    self.options.cancelCallback();
                }
            });
            }
        },

        _submitEvent: function () {
            var self = this;
            if (self.options.submitButtonId) {
            self.options.dialog.find('#' + self.options.submitButtonId).on('click', function () {
                self._formSubmit();
            });
            }
        },

        _formSubmit: function () {
            var self = this;
            var formParams = self._getFormParams();
            $.caPost(
                self.options.form.attr('action'),
                formParams,
                function (response) {
                    if (response.success || response.status) {
                        self.options.dialog.remove();
                        if (self.options.submitCallback && $.isFunction(self.options.submitCallback)) {
                            self.options.submitCallback(response);
                        }
                    } else {
                        if (response.formHtml !== undefined) {
                            self.options.dialog.html(response.formHtml);
                        } else if (response.content !== undefined) {
                            self.options.dialog.html(response.content);
                        }
                        self.options.form = self.options.dialog.find('form');
                        self._bindEvents();
                        $('body').caLoadingSplash('hide');
                    }
                },
                'json'
            );
        },

        _getFormParams: function () {
            return this.options.form.serialize();
        }
    });
})(jQuery);
